import { RefObject, useEffect } from 'react';
import { atom, useAtom } from 'jotai';

import { TabType, TabTypeValue } from '../constants/tab_menu';

const HEADER_HEIGHT = 120;
const active_tab_type_atom = atom<TabType>(TabType.PRODUCT_DETAIL_INFO);
const container_ref_atom = atom<RefObject<HTMLDivElement> | null>(null);
const tab_ref_atom = atom<RefObject<HTMLDivElement> | null>(null);

export function useProductPreviewAtiveTabType(option?: {
  container_ref?: RefObject<HTMLDivElement>;
  tab_ref?: RefObject<HTMLDivElement>;
  onUpdate?: (delay?: number) => void;
}) {
  const [active_tab_type, setActiveTabType] = useAtom(active_tab_type_atom);
  const [container_ref, setContainerRef] = useAtom(container_ref_atom);
  const [tab_ref, setTabRef] = useAtom(tab_ref_atom);

  useEffect(() => {
    if (option?.container_ref) {
      setContainerRef(option?.container_ref);
    }
    if (option?.tab_ref) {
      setTabRef(option?.tab_ref);
    }
  }, [option?.container_ref, option?.tab_ref, setContainerRef, setTabRef]);

  const update = (tabType: TabType | keyof typeof TabType, tab_focus = true) => {
    if (typeof tabType === 'string') {
      setActiveTabType(TabTypeValue[tabType]);
      option?.onUpdate?.();
    } else {
      setActiveTabType(tabType);
      option?.onUpdate?.();
    }

    if (tab_focus) {
      setTimeout(() => {
        if (
          container_ref!.current instanceof HTMLDivElement === false ||
          tab_ref!.current instanceof HTMLDivElement === false
        ) {
          return;
        }

        const top = tab_ref!.current!.getBoundingClientRect().top;
        const header_offset = HEADER_HEIGHT;
        const offset_position = top + container_ref!.current!.scrollTop - header_offset;
        container_ref?.current?.scrollTo({
          top: offset_position,
          behavior: 'smooth',
        });
      }, 300);
    }
  };

  return [active_tab_type, update] as const;
}
